import { CONSTANTS } from '@shared/constants';
import {
  ACCOUNT_CAMPAIGNS_ROUTES_PATHS_FULL,
  ACCOUNT_CAMPAIGNS_ROUTES_PATHS_PARTIALS,
} from './acc-campaigns/acc-campaigns-routes-paths';
import {
  ACCOUNT_ONE_MORE_QUESTION_ROUTES_PATHS_FULL,
  ACCOUNT_ONE_MORE_QUESTION_ROUTES_PATHS_PARTIALS,
} from './acc-one-more-question/acc-one-more-question-routes-paths';
import {
  ACCOUNT_USERS_ROUTES_PATHS_FULL,
  ACCOUNT_USERS_ROUTES_PATHS_PARTIALS,
} from './acc-users/acc-users-routes-paths';
import {
  ACCOUNT_VENUES_ROUTES_PATHS_FULL,
  ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS,
} from './acc-venues/acc-venues-routes-paths';

export const ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS: Readonly<{
  BASE_PATH: string;
  DETAILS: string;
  GOALS: string;
  GROUPS: string;
  FOODBACK_QUESTIONS: string;
  USERS: string;
  VENUES: string;
  WHEEL_OF_FORTUNE: string;
  ONE_MORE_QUESTION: string;
  CAMPAIGNS: string;
  REPORT_ARCHIVE: string;
}> = {
  BASE_PATH: `${CONSTANTS.ROUTES.ACCOUNT}/:${CONSTANTS.ROUTE_PARAMS.ACCOUNT_ID}/${CONSTANTS.ROUTES.SETTINGS}`,
  DETAILS: CONSTANTS.ROUTES.ACCOUNT_DETAILS,
  GOALS: CONSTANTS.ROUTES.GOALS,
  GROUPS: CONSTANTS.ROUTES.GROUPS,
  FOODBACK_QUESTIONS: CONSTANTS.ROUTES.FOODBACK_QUESTIONS,
  USERS: ACCOUNT_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH,
  VENUES: ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.BASE_PATH,
  WHEEL_OF_FORTUNE: CONSTANTS.ROUTES.WHEEL_OF_FORTUNE,
  ONE_MORE_QUESTION: ACCOUNT_ONE_MORE_QUESTION_ROUTES_PATHS_PARTIALS.BASE_PATH,
  CAMPAIGNS: ACCOUNT_CAMPAIGNS_ROUTES_PATHS_PARTIALS.BASE_PATH,
  REPORT_ARCHIVE: CONSTANTS.ROUTES.REPORT_ARCHIVE,
};

export const ACCOUNT_SETTINGS_ROUTES_PATHS_FULL = {
  DETAILS: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.DETAILS}`,
  GOALS: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.GOALS}`,
  WHEEL_OF_FORTUNE: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.WHEEL_OF_FORTUNE}`,
  GROUPS: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.GROUPS}`,
  FOODBACK_QUESTIONS: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.FOODBACK_QUESTIONS}`,
  ONE_MORE_QUESTION: {
    BASE_PATH: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.ONE_MORE_QUESTION}`,
    CREATE: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_ONE_MORE_QUESTION_ROUTES_PATHS_FULL.CREATE}`,
    EDIT: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_ONE_MORE_QUESTION_ROUTES_PATHS_FULL.EDIT}`,
  },
  CAMPAIGNS: {
    BASE_PATH: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.CAMPAIGNS}`,
    CREATE: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_CAMPAIGNS_ROUTES_PATHS_FULL.CREATE}`,
    EDIT: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_CAMPAIGNS_ROUTES_PATHS_FULL.EDIT}`,
  },
  USERS: {
    BASE_PATH: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.USERS}`,
    INVITE: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_USERS_ROUTES_PATHS_FULL.INVITE}`,
    EDIT: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_USERS_ROUTES_PATHS_FULL.EDIT}`,
    LIST: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.USERS}`,
  },
  VENUES: {
    CREATE: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_VENUES_ROUTES_PATHS_FULL.CREATE}`,
    EDIT: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_VENUES_ROUTES_PATHS_FULL.EDIT}`,
    LIST: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_VENUES_ROUTES_PATHS_FULL.LIST}`,
  },
  REPORT_ARCHIVE: {
    BASE_PATH: `${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_SETTINGS_ROUTES_PATHS_PARTIALS.REPORT_ARCHIVE}`,
  },
} as const;
